/*
 * WaWiAuftragEinerTT.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-24 in huWaWi3 33.11.2
 * Copyright (c) 2023 HUDORA GmbH
 */

import { LadeChecker } from '@hudora/hd-react-components'
import * as R from 'ramda'
import React from 'react'
import { useQuery } from 'urql'

import { LinkRender } from '../../lib/hd-link'
import { HdCard } from '../components/HdCard'
import { AUFTRAGBELEGE_QUERY } from './WaWiAuftragAppQueries'

export function TtVorgaenge({ auftrag, nr }) {
  const [{ fetching: loading, error, data }] = useQuery({ query: AUFTRAGBELEGE_QUERY, variables: { nr } })
  return (
    <HdCard title="Vorgänge">
      <div title="Track & Trace">
        <LadeChecker loading={loading} error={error} empty={!data?.entity?.belege}>
          <Nves auftrag={auftrag} belege={data?.entity?.belege} />
        </LadeChecker>
        {data?.entity?.belege.length > 1 ? null : <div>Noch keine T&T Vorgänge</div>}
      </div>
    </HdCard>
  )
}

function Nves({ auftrag, belege }) {
  const nves: any[] = R.uniq(
    (belege || [])
      ?.map((x) => JSON.parse(x.raw))
      ?.filter((x) => x.belegart !== 'Sammelrechnung')
      ?.map((x) => x?.logistik?.nves)
      ?.flat()
  )
  return (
    <section>
      <ul>
        {nves?.map((x, i) => (
          <li key={i}>{x?.nve ? <LinkRender value={x?.nve} /> : `leere NVE: ${JSON.stringify(x)}`}</li>
        ))}
      </ul>
    </section>
  )
}
